'use strict';

const {
  removeElement,
  getElementById,
  addClass,
  removeClass,
} = require('./utils');

const getFormFieldElement = element => {
  let formFieldElement = element.parentElement;
  while (
    !formFieldElement
      .getAttribute('class')
      .match(/form-field|gig-field|gig-selectable|gig-row/)
  ) {
    formFieldElement = formFieldElement.parentElement;
  }
  return formFieldElement;
};

module.exports = document => {
  const isGigField = () => window.GIG && window.GIG.Forms;
  const getErrorMessageElement = (id, message) => {
    const element = document.createElement('p');
    element.setAttribute('id', id);
    addClass(element, 'error');
    element.innerHTML = message;
    return element;
  };

  return {
    removeError(element) {
      const elementId = element.getAttribute('id');
      const elementErrorId = `error-${elementId}`;
      removeElement(elementErrorId);
      removeClass(element.parentNode, 'error');
    },
    validate(e, config, I18n) {
      if (!e) {
        return true;
      }
      let hasError = false;
      let curr = 0;
      while (!hasError && curr < config.length) {
        const entry = config[curr++];
        const element = e.target ? e.target : e;
        const elementId = element.getAttribute('id');
        const elementErrorId = `error-${elementId}`;
        const formFieldElement = getFormFieldElement(element);
        const value =
          element.type === 'checkbox' ? element.checked : element.value;
        if (getElementById(elementErrorId)) {
          removeElement(elementErrorId);
        }
        if (!entry.validateFn(value)) {
          if (isGigField()) {
            window.GIG.Forms.addError(
              `#${elementId}`,
              I18n.t(entry.messageKey)
            );
          } else {
            addClass(formFieldElement, 'error');
            if (!getElementById(elementErrorId)) {
              const errorElement = getErrorMessageElement(
                elementErrorId,
                I18n.t(entry.messageKey)
              );
              formFieldElement.parentNode.insertBefore(
                errorElement,
                formFieldElement
              );
            }
          }
          element.focus();
          hasError = true;
        } else {
          if (isGigField()) {
            window.GIG.Forms.success(`#${elementId}`);
          } else {
            removeClass(formFieldElement, 'error');
          }
          hasError = false;
        }
      }
      return !hasError;
    },
  };
};
